import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ZeplinIcon } from './icon';
import { ZeplinIconBorderless } from './icon-borderless';
import { ZeplinSearchResultIcon } from './search-result-icon';

export const zeplinConfig: ThirdPartyConfig = {
	displayName: 'Zeplin',
	id: 'zeplin',
	resourceType: 'smartlinks-connector-zeplin',
	icon: get3PLogo(ZeplinIcon, 'Zeplin', 'medium'),
	iconBorderless: get3PLogo(ZeplinIconBorderless, 'Zeplin', 'small'),
	searchResultIcon: get3PLogo(ZeplinSearchResultIcon, 'Zeplin', 'large'),
	integrationAri: 'ari:cloud:platform::integration/zeplin',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
